<template>
  <div class="findings">
    <div id="findings-chart-legend">
      <div class="toggle-container">
        <span class="label">Disability EDSS</span>
        <label class="switch">
          <!-- Disability EDSS -->
          <input type="checkbox" id="togBtn" />
          <div @click="toggleLine('edss')" class="slider round edss">
            <span class="on edss">off</span>
            <span class="off edss">on</span>
          </div>
        </label>
      </div>
      <div class="toggle-container">
        <span class="label">Axonal degeneration</span>
        <label class="switch">
          <!-- Disability EDSS -->
          <input type="checkbox" id="togBtn" />
          <div @click="toggleLine('axonal')" class="slider round axonal">
            <span class="on axonal">off</span>
            <span class="off axonal">on</span>
          </div>
        </label>
      </div>
      <div class="toggle-container">
        <span class="label">Demyelination</span>
        <label class="switch">
          <!-- Disability EDSS -->
          <input type="checkbox" id="togBtn" />
          <div
            @click="toggleLine('demyelination')"
            class="slider round demyelination"
          >
            <span class="on demyelination">off</span>
            <span class="off demyelination">on</span>
          </div>
        </label>
      </div>
      <div class="toggle-container">
        <span class="label">Clinical Threshold</span>
        <label class="switch">
          <!-- Disability EDSS -->
          <input type="checkbox" id="togBtn" />
          <div
            @click="toggleLine('threshold'), toggleLine('Rectangle_470')"
            class="slider round threshold"
          >
            <span class="on threshold">off</span>
            <span class="off threshold">on</span>
          </div>
        </label>
      </div>
    </div>
    <div id="findings-chart">
      <div class="chart">
        <svg
          class="2dchart"
          alt="As disease progresses in years, disability score, axonal degeneration, and cortical demyelination increase. Relapses are characterized by peaks in both disability E D S S and demyelination."
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="923.998"
          height="119.953"
          viewBox="0 0 923.998 119.953"
        >
          <defs>
            <linearGradient
              id="linear-gradient"
              x1="0.5"
              x2="0.5"
              y2="1"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#a7c9ea" />
              <stop offset="1" stop-color="#a7c9ea" stop-opacity="0" />
            </linearGradient>
          </defs>
          <g
            id="Group_1560"
            data-name="Group 1560"
            transform="translate(-239.986 -705.685)"
          >
            <g
              id="Group_1552"
              data-name="Group 1552"
              transform="translate(0 -16)"
            >
              <rect
                id="Rectangle_470"
                data-name="Rectangle 470"
                width="915"
                height="49"
                transform="translate(241 790)"
                fill="url(#linear-gradient)"
              />
              <g
                id="Group_1538"
                data-name="Group 1538"
                transform="translate(240.986 726.515)"
              >
                <path
                  id="Path_1958"
                  data-name="Path 1958"
                  d="M5847.59,1549.014H4932.457V1436.257"
                  transform="translate(-4932.457 -1436.257)"
                  fill="none"
                  stroke="#b7bcc3"
                  stroke-miterlimit="10"
                  stroke-width="2"
                />
              </g>
            </g>
            <g id="Group_1559" data-name="Group 1559">
              <g
                id="Group_1551"
                data-name="Group 1551"
                transform="translate(0 -16)"
              >
                <path
                  id="edss"
                  data-name="edss"
                  d="M22.15,234.557,38.8,230.395l14.982-1.665,2.5-5.41,31.213-1.665,7.491-61.681,6.242,58.768h23.722v-4.578l46.195-2.081L185.7,146.745l12.069,57.847h31.213l85.314-10.4,9.572-37.039,7.486,32.441,162.727-10.8,12.485-55.35,10.691,48.766,60.7-7.245,9.759-9.892,10,6.406,68.657-7.654,9.156-12.9,5.41,9.156L798.3,138.422l17.063-11.653,9.572,5.826,91.557-11.237"
                  transform="translate(239.486 605.154)"
                  fill="none"
                  stroke="#a5a5a5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="3"
                />
                <path
                  id="axonal"
                  data-name="axonal"
                  d="M915.731,142.2l-406.6,26.219-9.988,20.392L328.935,190.89,317.7,199.629l-50.772,6.243H180.364v5.41H147.486v4.162H124.181v4.578H96.714L86.31,227.1H33.457l-23.722,8.74"
                  transform="translate(240.389 603.876)"
                  fill="none"
                  stroke="#1062a7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="3"
                />
                <path
                  id="demyelination"
                  data-name="demyelination"
                  d="M20.266,236.489l18.1-2.185,8.739-12.173,10.924,11.861,29.652-1.873,6.555-48.692,6.555,47.443,78.031-5.306,7.8-48.067,8.427,39.328,56.807-1.249,10.924-17.791L273.4,214.64l43.073-.312,7.491-45.882,9.052,36.831,58.992-.312,11.236-12.381,10.612,11.445,83.962-2.809,8.115-39.312,8.739,21.833,401.705-30.9"
                  transform="translate(239.742 603.223)"
                  fill="none"
                  stroke="#ec9a1e"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-miterlimit="10"
                  stroke-width="3"
                />
                <path
                  id="threshold"
                  data-name="threshold"
                  d="M0,0,163.642.175C402.221.43,829.257.883,923,.964"
                  transform="translate(240.986 789.754)"
                  fill="none"
                  stroke="#585858"
                  stroke-linecap="round"
                  stroke-width="3"
                  stroke-dasharray="5 10"
                />
              </g>
            </g>
          </g>
        </svg>

        <p class="y-axis-label">Disablility Score</p>
      </div>
    </div>
  </div>
</template>

<script>
import yearListenerMixin from '@/mixins/yearListenerMixin';
import progressionMixin from '@/mixins/progressionMixin';

export default {
  name: 'FindingsChart',
  mixins: [yearListenerMixin, progressionMixin],

  data() {
    return {
      edssToggle: false,
      axonalToggle: false,
      demyelinationToggle: false,
      thresholdToggle: false,
    };
  },

  updated() {
    console.log('hello');

    this.$nextTick(function() {
      const edss = document.getElementById('edss');
      const axonal = document.getElementById('axonal');
      const demyelination = document.getElementById('demyelination');
      const threshold = document.getElementById('threshold');
      const threshold2 = document.getElementById('Rectangle_470');

      if (this.edssToggle) {
        edss.classList.remove('hide');
      } else {
        edss.classList.add('hide');
      }

      if (this.axonalToggle) {
        axonal.classList.remove('hide');
      } else {
        axonal.classList.add('hide');
      }

      if (this.demyelinationToggle) {
        demyelination.classList.remove('hide');
      } else {
        demyelination.classList.add('hide');
      }

      if (this.thresholdToggle) {
        threshold.classList.remove('hide');
        threshold2.classList.remove('hide');
      } else {
        threshold.classList.add('hide');
        threshold2.classList.remove('hide');
      }
    });
  },

  methods: {
    toggleLine(graph) {
      var lineGraph = document.getElementById(graph);
      lineGraph.classList.toggle('hide');
      this.toggleButton(graph);
    },
    toggleButton(button) {
      switch (button) {
        case 'edss':
          this.edssToggle = !this.edssToggle;
          break;
        case 'axonal':
          this.axonalToggle = !this.axonalToggle;
          break;
        case 'demyelination':
          this.demyelinationToggle = !this.demyelinationToggle;
          break;
        case 'threshold':
          this.thresholdToggle = !this.thresholdToggle;
          break;
        default:
        // code block
      }
    },
  },
};
</script>

<style lang="scss">
.findings {
  @include breakpoint(xs) {
    width: 935px;
  }
}

#findings-chart {
  background: $grey;
  padding: rem(10px) rem(20px);

  @include breakpoint(xs) {
    width: 935px;
  }

  * {
    color: $blue-dark-bg;
  }

  h2 {
    margin-bottom: 1rem;
  }

  .subtitle {
    font-size: 1rem;
    width: 100%;
  }

  .chart {
    position: relative;

    svg {
      display: block;
      width: 100%;
      @include breakpoint(lg) {
        height: 100%;
      }
    }
    .y-axis-label {
      position: absolute;
      top: rem(52px);
      left: rem(-60px);
      transform: rotate(-90deg);
      transform-origin: center;
      font-size: rem(12px);
      @include breakpoint(xs) {
        left: rem(-70px);
      }
    }
  }
}

#findings-chart-legend {
  font-size: rem(12px);
  margin-bottom: 0.5rem;
  margin-top: 1.5rem;
  display: flex;
  @include breakpoint(xs) {
    display: flex;
    width: 300px;
    // width: calc(100vw - 90px);
    justify-content: flex-start;
    flex-wrap: wrap;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 20;
    margin-top: 0.5rem;
    margin-bottom: 0;
  }
}

.toggle {
  width: 30px;
}

.hide {
  display: none;
}

.toggle-container {
  display: flex;
  align-items: center;
  @include breakpoint(xs) {
    margin-bottom: 10px;
  }
}

.label {
  font-size: rem(11px);
  color: $grey-darker;
  margin-right: 7px;
  @include breakpoint(xs) {
    font-size: rem(10px);
  }
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin-right: 15px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border: 1px solid $grey-med;
}

.slider:before {
  position: absolute;
  content: '';
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border: 1px solid $grey-darker;
}
.edss:before {
  background-color: #a5a5a5;
}
.axonal:before {
  background-color: #1062a7;
}
.demyelination:before {
  background-color: #ec9a1e;
}
.threshold:before {
  background-color: #585858;
}

input:checked + .slider {
  background-color: $white;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

/*------ ADDED CSS ---------*/
.on {
  display: none;
}

.on,
.off {
  color: $black;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 30%;
  font-size: 9.5px;
  font-weight: $font-weight-bold;
  &.edss {
    color: $grey-darker;
  }
  &.axonal {
    color: #1062a7;
  }
  &.demyelination {
    color: #ec9a1e;
  }
  &.threshold {
    color: #585858;
  }
}
.off {
  left: 70%;
}

input:checked + .slider .on {
  display: block;
}

input:checked + .slider .off {
  display: none;
}

/*--------- END --------*/

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
